import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TermsComponent implements OnInit {

  checked = false;
  dataUser : any;
  token = "";
  userName = "";
  userMail = "";
  loading = false;
  constructor(
    private userService: UsuarioService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;
    //validateUserLogeado
    let data = this.userService.getLocalStorage();
    this.dataUser = data['user'];
    this.token = data['token'];
    this.validateUser(data);

  }

  validateUser(data){
    if(data['user'] != null && data['token'].length > 5){
      
      if(data['user']['terminos']){
        window.location.href = "#/dashboard";
      }else{
        this.loading = false;
        this.userName = this.dataUser['name'];
        this.userMail = this.dataUser['email'];
      }
    }else{
      window.location.href = "#/";
    }
  }

  changeAccount(){
    this.userService.clearLocalStorage();
    setTimeout(() => {
      window.location.href = "/";
    }, 200);
  }

  updateTerms(){
    this.loading = true;
    this.userService.updateTerms(this.token, { "terminos": this.checked }).subscribe(res =>{
      if(res['status'] === 'success'){
        this.userService.saveLocalStorage(res['user_db'], this.token);
        this.loading = false;
        setTimeout(() => {
          window.location.href = "#/dashboard";
        }, 200);
      }else{
        this.loading = false;
      }
    })
  }
}
